import { render } from "./share.vue?vue&type=template&id=038ab5a9"
const script = {}

import exportComponent from "/Users/einaroberg/projects/tjing-majblomman/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__